import { E2EElement, E2EPage, newE2EPage } from "@stencil/core/testing";

describe("[gx-ide-mcp-server][basic]", () => {
  let page: E2EPage;
  let componentRef: E2EElement;

  beforeEach(async () => {
    page = await newE2EPage({
      failOnConsoleError: true,
      html: `<gx-ide-mcp-server></gx-ide-mcp-server>`
    });

    await page.evaluate(() => {
      const el = document.querySelector(
        "gx-ide-mcp-server"
      ) as HTMLGxIdeMcpServerElement;
      el.status = "stopped";
      el.initialLoading = false;
      el.startCallback = async () => ({
        success: true,
        port: 3000,
        endpoint: "http://localhost:3000/mcp"
      });
      el.stopCallback = async () => ({ success: true });
      el.copyCallback = () => {};
      el.closeCallback = () => {};
    });

    await page.waitForChanges();
    componentRef = await page.find("gx-ide-mcp-server");
  });

  it("should have a shadowRoot", () => {
    expect(componentRef.shadowRoot).toBeTruthy();
  });

  it('should have the "widget" class', () => {
    expect(componentRef.getAttribute("class")).toContain("widget");
  });

  it("should render the header title", async () => {
    const header = await page.find(
      "gx-ide-mcp-server >>> .title"
    );
    expect(header).toBeTruthy();
  });

  it("should render the status badge", async () => {
    const badge = await page.find(
      "gx-ide-mcp-server >>> .status-badge"
    );
    expect(badge).toBeTruthy();
  });

  it("should render the close button", async () => {
    const closeButton = await page.find(
      "gx-ide-mcp-server >>> [part='button-cancel']"
    );
    expect(closeButton).toBeTruthy();
  });

  it("should render the start button when stopped", async () => {
    const primaryButton = await page.find(
      "gx-ide-mcp-server >>> [part='button-confirm']"
    );
    expect(primaryButton).toBeTruthy();
  });
});

describe("[gx-ide-mcp-server][running]", () => {
  let page: E2EPage;

  beforeEach(async () => {
    page = await newE2EPage({
      failOnConsoleError: true,
      html: `<gx-ide-mcp-server></gx-ide-mcp-server>`
    });

    await page.evaluate(() => {
      const el = document.querySelector(
        "gx-ide-mcp-server"
      ) as HTMLGxIdeMcpServerElement;
      el.status = "running";
      el.initialLoading = false;
      el.serverPort = 3000;
      el.serverEndpoint = "http://localhost:3000/mcp";
      el.startCallback = async () => ({
        success: true,
        port: 3000,
        endpoint: "http://localhost:3000/mcp"
      });
      el.stopCallback = async () => ({ success: true });
      el.copyCallback = () => {};
      el.closeCallback = () => {};
    });

    await page.waitForChanges();
  });

  it("should show the status card when running", async () => {
    const statusCard = await page.find(
      "gx-ide-mcp-server >>> .status-card"
    );
    expect(statusCard).toBeTruthy();
  });

  it("should display the endpoint in the status card", async () => {
    const endpointValue = await page.find(
      "gx-ide-mcp-server >>> .endpoint-value"
    );
    expect(endpointValue).toBeTruthy();
    expect(endpointValue.textContent).toContain(
      "http://localhost:3000/mcp"
    );
  });
});
